angular.module('bmsApp.trugreen.job').controller('TGTreatmentProductModalCtrl', function ($scope,
																						  $modalInstance,
																						  $q,
																						  $ngBootbox,
																						  TGProductSvc,
																						  $filter,
																						  $timeout,
																						  ConfigService,
																						  TaxHelperSvc,
																						  TGTreatmentSvc,
																						  tgTreatment,
																						  tgProduct) {


	function init() {
		self.product = tgProduct;
		self.treatment = tgTreatment;
		reCalculateProductCost();

		var params = {
			page: 1,
			filter: {
				treatment: tgTreatment.treatment.treatment_attr.id
			}
		};
		TGProductSvc.productList.index(params).then(function (response) {
			self.options.products = response.data.tg_products_list;
			self.loading = false;
		});
	}

	function reCalculateProductCost() {
		console.log('recalc', self.product);
		var costOfProduct = parseFloat(self.treatment.treatment.lawn_size_m2) * parseFloat(self.product.product_attr.cost_per_m2);
		self.product.product_cost = (costOfProduct * parseFloat(self.treatment.treatment.treatments_per_year)).toFixed(3);

		var costPerAnnum = parseFloat(self.treatment.treatment.annual_treatment_price_net);
		if (costPerAnnum > 0) {
			self.product.product_cost_percent = ((parseFloat(self.product.product_cost)) / costPerAnnum * 100).toFixed(2);
		} else {
			self.product.product_cost_percent = 0;
		}
		// self.product.product_cost_percent = ((100 * self.product.product_cost) / costPerAnnum).toFixed(2);
	}

	function cancel() {
		$ngBootbox.confirm('Are you sure you want to do this?')
			.then(function () {
				$modalInstance.dismiss('cancel');
			});
	}

	function submit() {
		if (self.formValidator.valid()) {
			self.product.chemical_record = null; // reset any chemical record if one exist

			var modalResult = {
				product: self.product
			};
			$modalInstance.close(modalResult);
		}
	}

	var self = $scope.TGTreatmentProductCtrl = {
		formvalidatorconfig: {},
		formValidator: {},
		loading: true,
		processing: false,
		product: null,
		options: {},
		methods: {
			init: init,
			cancel: cancel,
			submit: submit,
			reCalculateProductCost: reCalculateProductCost,
		}
	};


});
